import { TIME_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import moment from 'moment-timezone';

export const sortTimeSlots = (timeSlotA, timeSlotB) => {
  // If both have startTime, sort by startTime
  if (timeSlotA.startTime && timeSlotB.startTime) {
    return timeSlotA.startTime - timeSlotB.startTime;
  }
  // If only a has startTime, a comes first
  if (timeSlotA.startTime && !timeSlotB.startTime) {
    return -1;
  }
  // If only b has startTime, b comes first
  if (!timeSlotA.startTime && timeSlotB.startTime) {
    return 1;
  }
  // If neither has startTime, maintain original order
  return 0;
};

// Helper function to check if two time slots overlap
export const doSlotsOverlap = (slot1, slot2) => {
  const start1 = moment(slot1.startTime, TIME_DISPLAY_FORMATS.SLASHED_HOUR_MINUTE);
  const end1 = moment(slot1.endTime, TIME_DISPLAY_FORMATS.SLASHED_HOUR_MINUTE);
  const start2 = moment(slot2.startTime, TIME_DISPLAY_FORMATS.SLASHED_HOUR_MINUTE);
  const end2 = moment(slot2.endTime, TIME_DISPLAY_FORMATS.SLASHED_HOUR_MINUTE);

  return start1.isBefore(end2) && end1.isAfter(start2);
};
